import React, { useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { TextInput, Button, IconButton, useTheme } from 'react-native-paper';
import { X } from 'lucide-react-native';

interface CommentInputProps {
  onSubmit: (text: string) => void;
  initialValue?: string;
  placeholder?: string;
  submitLabel?: string;
  onCancel?: () => void;
}

export function CommentInput({
  onSubmit,
  initialValue = '',
  placeholder = 'Add a comment...',
  submitLabel = 'Post',
  onCancel,
}: CommentInputProps) {
  const theme = useTheme();
  const [text, setText] = useState(initialValue);

  // Update text when initialValue changes (for edit mode)
  useEffect(() => {
    setText(initialValue);
  }, [initialValue]);

  const handleSubmit = () => {
    if (!text.trim()) return;
    onSubmit(text.trim());
    setText('');
  };

  const handleCancel = () => {
    setText('');
    onCancel?.();
  };

  return (
    <View style={styles.container}>
      {onCancel && (
        <View style={styles.editHeader}>
          <IconButton
            icon={() => <X size={20} color={theme.colors.onSurface} />}
            size={20}
            onPress={handleCancel}
          />
        </View>
      )}

      <View style={styles.inputRow}>
        <TextInput
          mode='outlined'
          placeholder={placeholder}
          value={text}
          onChangeText={setText}
          multiline
          style={styles.input}
          maxLength={500}
          outlineColor={theme.colors.outline}
          activeOutlineColor={theme.colors.primary}
        />

        <Button
          mode='contained'
          onPress={handleSubmit}
          disabled={!text.trim()}
          style={styles.button}
        >
          {submitLabel}
        </Button>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  editHeader: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 8,
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: 8,
  },
  input: {
    flex: 1,
    maxHeight: 100,
  },
  button: {
    alignSelf: 'flex-end',
    marginBottom: 6,
  },
});
